module.exports = __webpack_public_path__ + "img/sbi-logo-color.0e18eff8.png";